<div class="prefixed-input">
  <input
    #inputRef
    type="text"
    class="h--40"
    pInputText
    appFormControlClasses
    [appForceInvalidClasses]="forceErrorState()"
    [readonly]="readonly()"
    [disabled]="isDisabled() || disabled()"
    [placeholder]="computedPlaceholder()"
    [value]="displayValue()"
    (input)="onInput(inputRef.value)"
    (keydown)="onKeydown($event)"
  />
</div>
